import { IconButton } from '../generic/IconButton';
import { Icons, Item } from '../layout/sidebar/Icons';

export const SidebarButtons = ({
  pseudoclass,
  setPseudoclass,
}: {
  pseudoclass: string;
  setPseudoclass: (value: string) => void;
}) => {
  return (
    <Icons>
      <div>
        <Item id="default-style-icon">
          <IconButton
            handleClick={() => setPseudoclass('none')}
            isActive={pseudoclass === 'none'}
          >
            <i className="icon-properties" />
          </IconButton>
        </Item>
        <Item id="hover-style-icon">
          <IconButton
            handleClick={() => setPseudoclass('hover')}
            isActive={pseudoclass === 'hover'}
          >
            <i className="icon-hover" />
            <span>hover</span>
          </IconButton>
        </Item>
        <Item id="active-style-icon">
          <IconButton
            handleClick={() => setPseudoclass('active')}
            isActive={pseudoclass === 'active'}
          >
            <i className="icon-active" />
            <span>active</span>
          </IconButton>
        </Item>
        <Item id="focus-style-icon">
          <IconButton
            handleClick={() => setPseudoclass('focus')}
            isActive={pseudoclass === 'focus'}
          >
            <i className="icon-focus" />
            <span>focus</span>
          </IconButton>
        </Item>
      </div>
    </Icons>
  );
};
